<template>
    <div class="company-page">
        <div class="banner link">
            <div class="mask">
                <img src="@/assets/images/sustainable/company/banner.png" alt="公司治理banner图片" />
            </div>
            <div class="content">
                <div class="wrap">
                    <h1>企业治理</h1>
                    <h3>共推高质量发展</h3>
                    <p class="desc">顺丰致力于实现企业价值与社会价值的融合统一，怀揣推动行业可持续发展的美好愿景，积极探索企业的可持续发展之路。</p>
                </div>
            </div>
        </div>
        <div class="main-content">
            <div class="content-target">
                <h3>2022关键数据</h3>
                <ul class="data-list">
                    <li class="data-item">
                        <div class="title"><span>96.5</span><sub>%</sub></div>
                        <div class="desc">上市主体内所有三线管理人员《反腐败承诺书》签署率</div>
                    </li>
                    <li class="data-item">
                        <div class="title"><span>100</span><sub>%</sub></div>
                        <div class="desc">供应商《廉洁协议》签署率</div>
                    </li>
                </ul>
            </div>
            <div class="card card-develop">
                <h3>可持续发展管理</h3>
                <div class="card-header link card-header-develop">
                    <div class="mask mask-blue-new"></div>
                    <p class="detail-wrap">
                        顺丰不断提升ESG管治水平，通过设立四级可持续发展管理架构，为可持续发展的目标和策略制定、定期评估以及相关风险的管理奠定稳固基础。<br />
                        2022年，董事会战略委员会新增可持续发展监管职责，负责监督和管理公司可持续发展事宜，将ESG专业管理工作提升至公司治理层。<br />
                        如您对顺丰可持续发展工作有任何建议与意见，请联系顺丰投资者关系办公室 sfir@sf-express.com , 或致电办公室热线：0755-36395338。
                    </p>
                </div>
                <div class="card-body">
                    <img src="@/assets/images/sustainable/company/shareholder.jpg" alt="可持续发展管理架构" />
                </div>
            </div>
            <div class="card card-risk">
                <h3>风控合规管理</h3>
                <div class="card-header link card-header-risk">
                    <div class="mask mask-blue-new"></div>
                    <p class="detail-wrap">
                        顺丰构建了完善的内控与风险管理体系，加强和规范公司内部管理，不断提高公司风险预防及管控效果，促进公司可持续健康发展。
                    </p>
                </div>
                <div class="card-body">
                    <div class="link link-esg">
                        <div class="mask"></div>
                        <div class="detail-wrap l-gray">
                            <h4>风险管理体系</h4>
                            <p class="text-left">
                                顺丰搭建了由董事会风险管理委员会领导的风险管理架构。董事会风险管理委员会下设风险委员会，是集团风险统筹管控的专业决策机构，主要负责对集团风险管理体系建设、制度、重大风险预防及重大危机应对进行审议及决策。风险委员会每季度、年度向董事会风险管理委员会进行汇报。
                            </p>
                        </div>
                    </div>
                    <div class="link link-esg">
                        <div class="mask esg-risk"></div>
                        <div class="detail-wrap d-gray">
                            <h4>ESG 风险管理</h4>
                            <p class="text-left">
                                顺丰在进行风险信息库的识别和梳理，以及一级、二级、三级风险等级划分中充分融入了环境、社会及管治类风险。
                                公司已识别和管理的ESG风险包括自然灾害风险、知识产权风险、舞弊风险、生产安全风险、人力资源管理风险等共计15项二级风险，以及碳中和风险、极端天气运营风险等四级风险，覆盖ESG领域的多个方面。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card card-business">
                <h3>商业道德管理</h3>
                <div class="card-header link card-header-bussiness">
                    <div class="mask mask-blue-new"></div>
                    <p class="detail-wrap">
                        2022年，顺丰从业人员《反腐败承诺书》签署率达94.6%，较2021年提升1.7%。其中，三线管理人员《反腐败承诺书》签署率96.5%。供应商《廉洁协议》签署率达100%。<br />
                        顺丰开展廉洁指数调研和反腐倡廉专题培训，组织全体员工学规、知规、守规。2022年累计开展线下反贪腐培训20场，员工反腐败教育总时长21,300小时。
                    </p>
                </div>
                <div class="card-body">
                    <img src="@/assets/images/sustainable/company/business.jpg" alt="商业道德管理" />
                </div>
            </div>
            <div class="card card-security">
                <h3>数据安全治理</h3>
                <div class="card-header link card-header-security">
                    <div class="mask mask-blue-new"></div>
                    <p class="detail-wrap">
                        顺丰时刻对信息安全及网络安全风险保持高度警觉。公司建立了决策、管理、落实的三层数据隐私与网络安全管理架构。技术委员会作为最高决策组织，负责信息安全决策、任命和指示，由首席执行官（CEO）担任技术委员会委员长，作为数据隐私与网络安全的最高负责人。
                    </p>
                </div>
                <div class="card-body">
                    <div class="link link-esg">
                        <div class="mask-security"></div>
                        <div class="detail-wrap l-gray">
                            <h4>网络安全</h4>
                            <p class="text-left">
                                顺丰制定了《信息安全事件应急预案》《网络安全事件管理规定》等内部制度，明确发生网络安全事件时的响应机制及处理措施，通过网络安全漏洞检测、网络安全实战演习，提升公司安全防御水平，为公司网络安全保驾护航。
                                顺丰自2020年起组建专业网络安全蓝军，持续开展内部红蓝演练对抗，通过模拟各种外部网络安全攻击手段，在红蓝演练中不断发现自身网络安全防御弱点并复盘改进，提升安全团队协同作战能力，为公司经营保驾护航。2022年，顺丰共开展了4次红蓝演练对抗。
                            </p>
                        </div>
                    </div>
                    <div class="link link-esg">
                        <div class="mask"></div>
                        <div class="detail-wrap d-gray">
                            <h4>信息安全</h4>
                            <p class="text-left">
                                顺丰高度重视信息安全管理，杜绝信息安全事件的发生。2022年，公司更新《信息安全高危行为管理办法》《信息安全奖惩管理办法》，明确信息安全高危行为及其违规处罚原则，通过设立特殊奖惩机制，强化全体员工保护公司内部信息的安全意识。
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="download">
                <a class="link" href="https://www.sf-express.com/uploads/2022_8a7477b59e.pdf" target="_blank">
                    <img src="@/assets/images/sustainable/download-icon.png" alt="下载《顺丰控股2022年度可持续发展报告》" />
                    <p>下载《顺丰控股2022年度可持续发展报告》</p>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SustainableCompany'
}
</script>

<style lang="scss" scoped>
@import './common.scss';
.wrap {
    padding-top: 0.96rem;
    padding-left: 0.8rem;
}
.company-page {
    background: #e8e8e8;
    .main-content {
        padding: 0.5rem 0.72rem;
        font-size: 0.3rem;
        line-height: 1.8;
        text-align: center;
        color: #000000;
        .content-target {
            text-align: left;
            .data-list {
                padding-bottom: 0.5rem;
                .data-item {
                    .title {
                        color: #0a669c;
                    }
                    .desc {
                        font-size: 0.24rem;
                    }
                }
                .gray {
                    color: #909090;
                }
            }
        }
        .card-develop {
            .card-body {
                padding: 0;
                background: #fff;
            }
            .btn {
                position: relative;
                border: solid 1px #0a669c;
                color: #0a669c;
                font-weight: bold;
                &.line {
                    &:before {
                        content: '';
                        position: absolute;
                        bottom: -1.02rem;
                        left: 50%;
                        width: 0.03rem;
                        height: 1.02rem;
                        background: #0a669c;
                    }
                }
                &.btn1 {
                    height: 0.64rem;
                    line-height: 0.64rem;
                    margin-bottom: 1rem;
                }
                &.btn2 {
                    line-height: 0.4rem;
                    padding: 0.14rem 0.16rem;
                    margin-bottom: 1rem;
                }
                &.btn3 {
                    padding-top: 0.2rem;
                    height: 1rem;
                    line-height: 0.4rem;
                }
            }
        }
        .card-business {
            .card-body {
                padding: 0;
                background: #fff;
            }
        }
        .target-list {
            padding: 0.2rem 0.72rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            dd {
                width: 2.8rem;
                height: 2.8rem;
                margin-bottom: 0.4rem;
            }
        }
    }
    .l-gray {
        line-height: 1.5;
        background-color: #d6d6d6;
    }
    .d-gray {
        line-height: 1.5;
        background-color: #d0d0d0;
    }
    .card {
        .card-header {
            &.card-header-develop {
                height: 6.76rem;
            }
            &.card-header-risk {
                height: 2.6rem;
            }
            &.card-header-bussiness {
                height: 5.8rem;
            }
            &.card-header-security {
                height: 4.8rem;
            }
        }
        .card-body {
            .mask {
                min-height: 6rem;
            }
            .mask-security {
                min-height: 8.4rem;
            }
            .link {
                &.link-esg {
                    color: #000;
                }
                &.link-risk .mask {
                    &:before {
                        opacity: 0.1;
                    }
                    background: #0a669c;
                }
                &.link-esg .mask {
                    &.esg-risk {
                        height: 6.5rem;
                    }
                    &:before {
                        opacity: 0;
                    }
                    background: #fff;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/sustainable/company.vue